import React from "react";
import './ProductSupport.scss';
import { Comment, Gmail } from "../../../../../../../assets/svg";



interface ISupportProps {

}

function ProductSupport({ ...props }: ISupportProps) {
    return (
        <div className="support-card">

            <div className="title">Support Desk</div>
            <div className="sub-title">Direct ways to get in touch with us.</div>
            <div className="ticket-button">
                <div className="icon-container">
                    <Comment />
                </div>
                <p>{'Submit a ticket'}</p>
            </div>

            <a
                className="ticket-button"
                href="mailto:support@walacor.com"
                target="_blank"
                rel="noopener noreferrer"
            >
                <div className="icon-container">
                    <Gmail />
                </div>
                <p>{'Email Us'}</p>
            </a>

        </div>
    )
}

export default ProductSupport;